import React from 'react';
import {style, classes} from './doppe-action-type-widget-content-section.st.css';

export const DoppeActionTypeWidgetContentSection = React.memo(function DoppeActionTypeWidgetContentSection (props: DoppeActionTypeWidgetContentSection.Props) {
    const {
        className,
        noPadding,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                noPadding: noPadding,
            }, className)}
        />
    );
});

export namespace DoppeActionTypeWidgetContentSection {

    export interface Props extends React.HTMLAttributes<any> {
        noPadding?: boolean;
    }
}
